import { createVanIconComponent } from "./van"

const GemOutlined = createVanIconComponent("gem-o")
export default GemOutlined
